import { FriendlyCaptchaSDK } from '@friendlycaptcha/sdk'

const sdk = new FriendlyCaptchaSDK()
const element = document.querySelector('.frc-captcha')

if (element) {
  sdk.createWidget({
    element,
    sitekey: element.dataset.sitekey || '',
    startMode: 'auto'
  })
}
